<template>
  <AuthContainer>
    <div class="text-left mb-8">
      <h1 class="text-3xl md:text-4xl font-semibold mb-4 mt-8">{{ $t('auth.signIn.title') }}</h1>
      <p class="text-gray-700 text-lg">{{ $t('auth.signIn.subtitle') }}</p>
    </div>

    <form @submit.prevent="onSubmit" class="space-y-6 text-sm">
      <BaseInput
        id="email"
        :label="$t('auth.becomeMember.form.email')"
        type="email"
        v-model="form.userEmail.value.value"
        width="w-full"
        :onChange="form.userEmail.handleChange"
        :disabled="isLoading"
        :error="form.userEmail.errorMessage.value"
      />

      <BaseInput
        id="password"
        :label="$t('auth.resetPassword.form.password')"
        type="password"
        v-model="form.userLogin.value.value"
        width="w-full"
        :disabled="isLoading"
        :onChange="form.userLogin.handleChange"
        :error="form.userLogin.errorMessage.value"
      />

      <div class="text-right">
        <a
          href="#"
          class="text-md hover:text-main-hover transition-colors font-medium cursor-pointer"
          @click.prevent="handleForgotPassword"
        >
          {{ $t('auth.signIn.form.forgotPassword') }}
        </a>
      </div>
      <div v-if="userStore.errorWhileSignIn" class="p-3 bg-red-50 border border-red-200 rounded-md">
        <p class="text-sm text-red-600 text-center">{{ $t('auth.signIn.error') }}</p>
      </div>
      <BaseButton type="submit" :loading="isLoading" :disabled="!meta.valid" width="w-full">
        {{ isLoading ? $t('auth.signIn.form.signingIn') : $t('auth.signIn.form.signIn') }}
      </BaseButton>
    </form>

    <p class="mt-8 md:mt-12 2xl:mt-14 text-center text-sm">
      {{ $t('auth.signIn.question') }}

      <router-link
        append
        class="hover:text-main-hover cursor-pointer font-medium transition-colors"
        :to="{ name: RoutesKey.AUTH_SIGN_UP }"
      >
        {{ $t('auth.becomeMember.title') }}
      </router-link>
    </p>
  </AuthContainer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import BaseInput from '@/components/ui/BaseInput.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import { useUserStore } from '@/stores/userStore'
import { useRouter } from 'vue-router'
import { SignInForm } from '@/services/userAndAuth/forms/SignInForm'
import { RoutesKey } from '@/models/enums/app/RoutesKey'
import AuthContainer from './AuthContainer.vue'

const router = useRouter()
const userStore = useUserStore()
const { form, handleSubmit, meta } = SignInForm.getSignInForm()
const isLoading = ref(false)

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true
  await userStore.signIn(values)
  isLoading.value = false
})

const handleForgotPassword = () => {
  router.replace({
    name: RoutesKey.AUTH_FORGOT_PASSWORD,
  })
}
</script>
